<template>
    <div>
        <template v-if="getConfig('messages.enabled', true)">
            <v-row v-if="$vuetify.breakpoint.xs">
                <!-- Discussions -->
                <v-col v-if="!selectedConversationId" cols="12" xl="2" xs="12">
                    <ProgramAutocomplete v-if="isUser" class="mt-2 px-5" @input="fetchConversations(null, true)" ref="programAutocomplete" v-model="search.programs" label="Programme(s)" multiple noDynamicSearch />

                    <ContactAutocomplete v-if="isUser" v-model="search.buyers" @input="fetchConversations(null, true)" class="mt-2 px-5" label="Acquéreurs" />

                    <v-switch v-if="isUser" v-model="archived" @change="fetchConversations(null, true)" label="Afficher les conversations archivées" class="mt-2 px-5" />

                    <v-list shaped color="#f6f7ff">
                        <v-subheader class="mt-5" v-if="isUser">
                            <v-tabs v-model="tab" class="rounded mt-4" vertical grow>
                                <v-tab active-class="grey lighten-3"> Ma messagerie <v-badge v-if="ownConversationsHasUnreadMessages" color="red" inline dot> </v-badge> </v-tab>
                                <v-tab active-class="grey lighten-3"> Messagerie partagée <v-badge v-if="hasOtherNewMessages" color="red" inline dot> </v-badge> </v-tab>
                            </v-tabs>
                        </v-subheader>

                        <v-subheader :class="{ 'mt-7': isUser }">
                            Discussions

                            <v-spacer />

                            <CreateMessageGroupMenuUser v-if="$store.state.application.user.type === 'buyer'" @created="onConversationCreated" :activeConversations="conversations">
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                        <v-icon small> fas fa-plus </v-icon>
                                    </v-btn>
                                </template>
                            </CreateMessageGroupMenuUser>

                            <CreateMessageGroupMenuBuyer v-if="$store.state.application.user.type === 'user'" @created="onConversationCreated" :activeConversations="conversations">
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                        <v-icon small> fas fa-plus </v-icon>
                                    </v-btn>
                                </template>
                            </CreateMessageGroupMenuBuyer>
                        </v-subheader>

                        <v-list-item-group v-model="selectedConversationId">
                            <v-list-item v-for="(conversation, i) of conversations" :value="conversation.id" :key="i + '_' +conversation.id">
                                <v-list-item-avatar class="white--text text-uppercase" :color="getColorByName(getConversationDisplayName(conversation))" size="32">
                                    <v-img v-if="getConversationOtherUser(conversation) && getConversationOtherUser(conversation).profilePictureDocumentId" :src="getDocumentUrl(getConversationOtherUser(conversation).profilePictureDocumentId)" />
                                    <span v-else> {{ getConversationDisplayName(conversation) ? getConversationDisplayName(conversation).slice(0, 1) : '' }} </span>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title class="body-2">
                                        <template v-if="getConversationDisplayName(conversation)">
                                            {{ getConversationDisplayName(conversation) }}
                                        </template>
                                        <template v-else>
                                            <i> &lt;Compte Inactif&gt; </i>
                                        </template>
                                    </v-list-item-title>

                                    <v-list-item-subtitle v-if="conversation.message">
                                        <template v-if="conversation.message.isMe">
                                            Vous :
                                        </template>
                                        {{ conversation.message.content }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-badge v-if="conversation.unreadCount > 0" :content="conversation.unreadCount" color="red" inline dot>

                                    </v-badge>
                                </v-list-item-action>

                                <v-list-item-action v-show="false">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-btn small icon v-on="on">
                                                <v-icon small> fas fa-ellipsis-v </v-icon>
                                            </v-btn>
                                        </template>

                                        <v-list>
                                            <LeaveConversationDialog :conversation="conversation">
                                                <template v-slot:activator="{ on }">
                                                    <v-list-item v-on="on">
                                                        Quitter la conversation
                                                    </v-list-item>
                                                </template>
                                            </LeaveConversationDialog>
                                        </v-list>
                                    </v-menu>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-col>

                <v-divider vertical />

                <!-- Messages -->
                <v-col v-if="selectedConversationId" id="conversation" class="d-flex flex-column fill-height">
                    <v-row justify="center" @click="selectedConversationId = null;" class="cursor-pointer">
                        <v-col cols="12">
                            <v-btn class="mr-2" icon large>
                                <v-icon> fas fa-chevron-circle-left </v-icon>
                            </v-btn>

                            {{ this.currentDisplayName }}
                        </v-col>
                    </v-row>

                    <template v-if="isUser">
                        <v-tooltip v-if="archivedChipTooltip" bottom>
                            <template v-slot:activator="{ on }">
                                <v-chip class="mx-5 mb-3" color="blue" label dark v-on="on">
                                    <template v-if="selectedConversation.archived"> Conversation archivée </template>
                                    <template v-else> Conversation désarchivée </template>
                                </v-chip>
                            </template>
                            {{ archivedChipTooltip }}
                        </v-tooltip>

                        <v-btn v-if="tab === 0" @click="setConversationArchived(selectedConversation, !selectedConversation.archived)" color="primary" class="mx-5" v-on="on">
                            <template v-if="selectedConversation.archived">
                                Désarchiver la conversation
                            </template>
                            <template v-else>
                                Archiver la conversation
                            </template>
                        </v-btn>
                    </template>

                    <v-list ref="messageList" style="overflow-y: scroll" color="#f6f7ff">
                        <Message v-for="(message, i) of messages" :key="i + '_' + message.id" :messages="messages" :message="message" :index="i" @deleted="onMessageDeleted" @updated="onMessageUpdated" class="mt-6" />
                        <template v-if="messages.length === 0">
                            <v-row justify="center" align="center" style="height: 200px" no-gutters>
                                <v-col>
                                    <h3 class="text-center"> Aucun message </h3>
                                </v-col>
                            </v-row>
                        </template>
                    </v-list>

                    <v-divider />

                    <div v-if="selectedConversation && isBuyer && !isAllowedToSendMessage" class="pa-4">
                        Cette conversation est désormais inactive. Veuillez contacter votre nouvel interlocuteur.
                    </div>

                    <v-row justify="center">
                        <v-col cols="12" :style="{ 'visibility': isAllowedToSendMessage ? 'visible' : 'hidden' }">
                            <CreateMessageInput ref="createMessageInput" @created="onMessageCreated($event)" :messages="messages" :conversationId="selectedConversationId" :newRecipients="newRecipients" :firstMessage="messages.length === 0" class="mt-2" />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row v-if="!$vuetify.breakpoint.xs" class="mt-0" no-gutters>
                <!-- Discussions -->
                <v-col cols="3" xl="3">
                    <ProgramAutocomplete v-if="isUser" class="mt-2 px-5" @input="fetchConversations(null, true)" ref="programAutocomplete" v-model="search.programs" label="Programme(s)" multiple noDynamicSearch />

                    <ContactAutocomplete v-if="isUser" v-model="search.buyers" @input="fetchConversations(null, true)" class="mt-2 px-5" label="Acquéreurs" />

                    <v-switch v-if="isUser" v-model="archived" @change="fetchConversations(null, true)" label="Afficher les conversations archivées" class="mt-2 px-5" />

                    <v-list ref="conversationsList" shaped color="#f6f8fc" :style="{ 'height': messageContainerHeight, 'overflow': 'auto' }">
                        <v-subheader class="mt-5" v-if="isUser">
                            <v-tabs v-model="tab" class="rounded mt-4" vertical grow>
                                <v-tab active-class="grey lighten-2"> Ma messagerie <v-badge v-if="ownConversationsHasUnreadMessages" color="red" inline dot> </v-badge> </v-tab>
                                <v-tab active-class="grey lighten-2"> Messagerie partagée <v-badge v-if="hasOtherNewMessages" color="red" inline dot> </v-badge> </v-tab>
                            </v-tabs>
                        </v-subheader>

                        <v-subheader :class="{ 'mt-5': isUser }">
                            Discussions

                            <v-spacer />

                            <CreateMessageGroupMenuUser v-if="$store.state.application.user.type === 'buyer'" @created="onConversationCreated" :activeConversations="conversations">
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                        <v-icon small> fas fa-plus </v-icon>
                                    </v-btn>
                                </template>
                            </CreateMessageGroupMenuUser>

                            <CreateMessageGroupMenuBuyer v-if="$store.state.application.user.type === 'user' && tab === 0" @created="onConversationCreated" :activeConversations="conversations">
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                        <v-icon small> fas fa-plus </v-icon>
                                    </v-btn>
                                </template>
                            </CreateMessageGroupMenuBuyer>
                        </v-subheader>
                            
                        <v-list-item-group v-model="selectedConversationId">
                            <v-list-item v-if="newRecipients.length > 0" :value="newConversation.id">
                                <v-list-item-avatar class="white--text text-uppercase" :color="getColorByName(getConversationDisplayName(newConversation))" size="32">
                                    <v-img v-if="getConversationOtherUser(newConversation) && getConversationOtherUser(newConversation).profilePictureDocumentId" :src="getDocumentUrl(getConversationOtherUser(newConversation).profilePictureDocumentId)" />
                                    <span v-else> {{ getConversationDisplayName(newConversation) ? getConversationDisplayName(newConversation).slice(0, 1) : '' }} </span>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title class="body-2">
                                        {{ getConversationDisplayName(newConversation) }}
                                    </v-list-item-title>

                                    <v-list-item-subtitle v-if="newConversation.message">
                                        <template v-if="newConversation.message.isMe">
                                            Vous:
                                        </template>
                                        {{ newConversation.message.content }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-badge v-if="newConversation.unreadCount > 0" :content="newConversation.unreadCount" color="red" inline dot>

                                    </v-badge>
                                </v-list-item-action>
                            </v-list-item>
                            
                            <v-menu v-for="(conversation, i) of conversations" :key="conversation.id + '_' + i" open-on-hover offset-x>
                                <template v-slot:activator="{ on }">
                                    <v-list-item :value="conversation.id" class="my-3" v-on="on">
                                        <v-list-item-avatar class="white--text text-uppercase" :color="getColorByName(getConversationDisplayName(conversation))" size="32">
                                            <v-img v-if="getConversationOtherUser(conversation) && getConversationOtherUser(conversation).profilePictureDocumentId" :src="getDocumentUrl(getConversationOtherUser(conversation).profilePictureDocumentId)" />
                                            <span v-else> {{ getConversationDisplayName(conversation) ? getConversationDisplayName(conversation).slice(0, 1) : '' }} </span>
                                        </v-list-item-avatar>

                                        <v-list-item-content>
                                            <v-list-item-title class="body-2">
                                                <template v-if="getConversationDisplayName(conversation)">
                                                    {{ getConversationDisplayName(conversation) }}
                                                </template>
                                                <template v-else>
                                                    <i> &lt;Compte Inactif&gt; </i>
                                                </template>
                                            </v-list-item-title>

                                            <v-list-item-subtitle v-if="conversation.message">
                                                <template v-if="conversation.message.isMe">
                                                    Vous:
                                                </template>
                                                {{ conversation.message.content }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <template v-if="conversation.unreadCount > 0">
                                                <v-badge :content="conversation.unreadCount" color="red" inline dot>

                                                </v-badge>
                                            </template>
                                            <template v-else-if="tab === 0">
                                                <template v-if="getConversationMe(conversation) && getConversationMe(conversation).tag === 1">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn color="orange" @click.stop="toggleTag(conversation)" icon small v-on="on">
                                                                <v-icon small> fas fa-star </v-icon>
                                                            </v-btn>
                                                        </template>
                                                        Suivi
                                                    </v-tooltip>
                                                </template>
                                                <template v-else>
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn color="grey" @click.stop="toggleTag(conversation)" icon small v-on="on">
                                                                <v-icon small> fas fa-star </v-icon>
                                                            </v-btn>
                                                        </template>
                                                        Non suivi
                                                    </v-tooltip>
                                                </template>
                                            </template>
                                        </v-list-item-action>
                                    </v-list-item>
                                </template>

                                <v-card>
                                    <v-card-text>
                                        <template v-if="getConversationDisplayName(conversation)">
                                            {{ getConversationDisplayName(conversation) }}
                                        </template>
                                        <template v-else>
                                            <i> &lt;Compte Inactif&gt; </i>
                                        </template>

                                        <span class="mx-2"> | </span>

                                        Dernier message le

                                        {{ conversation.message.created | toDate() }}

                                        <template v-if="isUser">
                                            <br>

                                            <v-chip v-for="program of getConversationOtherBuyer(conversation).programs" :key="program.title" class="mr-1" small label>
                                                {{ program.title }} -
                                                <template v-for="product of program.products">
                                                    <span :key="product.reference" class="ml-1"> {{ product.reference }}</span>
                                                </template>
                                            </v-chip>
                                        </template>
                                    </v-card-text>
                                </v-card>
                            </v-menu>
                        </v-list-item-group>
                    </v-list>
                </v-col>

                <!-- Messages -->
                <v-col class="d-flex flex-column fill-height">
                    <v-card v-show="selectedConversation" color="white" flat class="mt-2">
                        <div v-if="selectedConversation" id="conversation-header" class="d-flex align-center pa-2">
                            <v-avatar class="white--text text-uppercase mr-2" :color="getColorByName(currentDisplayName)" size="32">
                                <v-img v-if="getConversationOtherUser(selectedConversation) && getConversationOtherUser(selectedConversation).profilePictureDocumentId" :src="getDocumentUrl(getConversationOtherUser(selectedConversation).profilePictureDocumentId)" />
                                <span v-else> {{ currentDisplayName.slice(0, 1) }} </span>
                            </v-avatar>

                            <span class="font-weight-medium text-h6 mr-2">
                                {{ currentDisplayName }}
                            </span>

                            <template v-if="isUser">
                                <span class="mr-2">
                                    |
                                </span>

                                <v-chip v-for="program of getConversationOtherBuyer(selectedConversation).programs" :key="program.title" class="mr-1" small label>
                                    {{ program.title }} -
                                    <template v-for="product of program.products">
                                        <span :key="product.reference" class="ml-1"> {{ product.reference }}</span>
                                    </template>
                                </v-chip>
                            </template>

                            <template v-if="isUser">
                                <v-tooltip v-if="archivedChipTooltip" bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-chip class="ml-5" color="blue" label dark v-on="on">
                                            <template v-if="selectedConversation.archived"> Conversation archivée </template>
                                            <template v-else> Conversation désarchivée </template>
                                        </v-chip>
                                    </template>
                                    {{ archivedChipTooltip }}
                                </v-tooltip>

                                <v-spacer />

                                <v-tooltip v-if="tab === 0" left>
                                    <template v-slot:activator="{ on }">
                                        <v-btn @click="setConversationArchived(selectedConversation, !selectedConversation.archived)" color="primary" class="mr-5" icon v-on="on">
                                            <v-icon>fas fa-archive</v-icon>
                                        </v-btn>
                                    </template>
                                    <template v-if="selectedConversation.archived">
                                        Désarchiver la conversation
                                    </template>
                                    <template v-else>
                                        Archiver la conversation
                                    </template>
                                </v-tooltip>
                            </template>
                        </div>

                        <v-divider />

                        <v-list class="px-10" ref="messageList" style="overflow-y: scroll" :style="{ 'height': messageContainerHeight }">
                            <v-row v-if="lastMessageReached" no-gutters class="my-4 grey--text text--darken-1" align="center">
                                <v-divider class="mr-4" />
                                Dernier message atteint
                                <v-divider class="ml-4" />
                            </v-row>

                            <Message v-for="(message, i) of messages" :key="message.id + '_' + i" :messages="messages" :message="message" :index="i" @deleted="onMessageDeleted" @updated="onMessageUpdated" @attachmentDeleted="onAttachmentDeleted" class="mt-6" />

                            <template v-if="messages.length === 0 && !isMessagesLoading && !isConversationsLoading">
                                <v-row justify="center" align="center" style="height: 200px" no-gutters>
                                    <v-col>
                                        <h3 class="text-center"> Aucun message </h3>
                                    </v-col>
                                </v-row>
                            </template>

                             <template v-if="messages.length === 0 && !isMessagesLoading && isConversationsLoading">
                                <v-row justify="center" align="center" style="height: 200px" no-gutters>
                                    <v-col>
                                        <h3 class="text-center"> Chargement de la messagerie </h3>
                                    </v-col>
                                </v-row>
                            </template>
                            <div v-if="selectedConversation && isBuyer && !isAllowedToSendMessage" class="pa-4">
                                Cette conversation est désormais inactive. Veuillez contacter votre nouvel interlocuteur.
                            </div>
                        </v-list>

                        <v-divider />

                        <v-row v-if="selectedConversation" id="message-input-container" justify="center" style="position: relative;" :style="{ 'visibility': isAllowedToSendMessage ? 'visible' : 'hidden' }">
                            <v-col cols="8">
                                <CreateMessageInput ref="createMessageInput" @created="onMessageCreated($event)" :messages="messages" :conversationId="selectedConversationId" :newRecipients="newRecipients" :firstMessage="messages.length === 0" class="mt-2" />
                            </v-col>
                        </v-row>

                        <v-overlay v-if="isMessagesLoading" z-index="999" absolute opacity="0.2">
                            <v-progress-circular indeterminate size="64" />
                        </v-overlay>
                    </v-card>

                    <v-card v-if="!selectedConversation"  :style="{ 'height': messageContainerHeight }" flat>
                        <div id="conversation-header"> </div>
                        <div id="message-input-container"> </div>
                        <v-row align="center" class="fill-height no-gutters">
                            <v-col>
                                <h1 class="text-center grey--text text--darken-2"> Aucune conversation sélectionnée </h1>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </template>
        <template v-else>
            <v-container>
                <v-row align="center" class="fill-height">
                    <v-col>
                        <h1 class="text-center grey--text text--darken-2"> La messagerie est désactivée </h1>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </div>
</template>

<script>
import documentsMixin from '../mixins/documents.js';
import messagesMixin from '../mixins/messages';
import Message from '../components/messages/Message.vue';
import ProgramAutocomplete from '../components/widgets/ProgramAutocomplete.vue';
import ContactAutocomplete from '../components/widgets/ContactAutocomplete.vue';
import CreateMessageInput from '../components/messages/CreateMessageInput.vue';
import LeaveConversationDialog from '../components/messages/LeaveConversationDialog.vue';
import CreateMessageGroupMenuUser from '../components/messages/CreateMessageGroupMenuUser.vue';
import CreateMessageGroupMenuBuyer from '../components/messages/CreateMessageGroupMenuBuyer.vue';

export default {
    name: 'Messages',

    mixins: [documentsMixin, messagesMixin],

    components: {
        Message,
        CreateMessageInput,
        ContactAutocomplete,
        ProgramAutocomplete,
        LeaveConversationDialog,
        CreateMessageGroupMenuUser,
        CreateMessageGroupMenuBuyer
    },

    data: () => ({
        tab: 0,
        newMessage: '',
        currentDisplayName: '',
        selectedConversationId: null,
        firstConversationFetch: true,
        lastMessageReached: false,
        setNotSeenTimeout: null,

        conversations: [],
        conversationsCurrentPage: 1,
        hasNoMoreConversations: false,
        ownConversationsHasUnreadMessages: false,
        otherConversationsHasUnreadMessages: false,
        isConversationsLoading: false,
        archived: false,

        messages: [],
        messagesCount: 0,
        messagesTotalPages: 1,
        messagesCurrentPage: 1,
        isMessagesLoading: false,

        newRecipients: [],
        redirectOnUserId: null,

        search: {
            programs: null,
            buyers: null
        },

        messageContainerHeight: '200px'
    }),

    methods: {
        async fetchConversations(groupId, resetPage) {
            try {
                this.isConversationsLoading = true;
                this.setLoading(true);

                if (resetPage) {
                    this.conversationsCurrentPage = 1;
                }

                const query = {
                    limit: 20,
                    include: 'users',
                    page: this.conversationsCurrentPage,
                    otherConversations: this.tab === 1 ? '1' : '0'
                };

                if (this.isUser) {
                    query.archived = this.archived ? '1' : '0';
                }

                if (Array.isArray(this.search.programs) && this.search.programs.length > 0) {
                    query.programs = this.search.programs.join(',');
                }

                if (this.search.buyers) {
                    query.buyer = this.search.buyers;
                }

                const { conversations, otherConversationsHasUnreadMessages, err } = await this.repos.messaging.getConversations(query);
                if (err) {
                    throw new Error(err);
                }
                this.hasNoMoreConversations = conversations.length === 0;
                if (resetPage) {
                    this.conversations = conversations;
                } else {
                    this.conversations = this.conversations.concat(conversations);
                }
                if (typeof otherConversationsHasUnreadMessages === 'boolean') {
                    this.otherConversationsHasUnreadMessages = otherConversationsHasUnreadMessages;
                }
                if (this.tab === 0) {
                    this.ownConversationsHasUnreadMessages = this.conversations.some((c) => c.unreadCount > 0);
                }

                if (this.conversations.length > 0) {
                    if (groupId) {
                        this.selectedConversationId = groupId;
                    }
                    if (this.isBuyer) {
                        this.selectedConversationId = this.conversations[0].id;
                    }
                }

                if (this.redirectOnUserId) {
                    const conversation = this.conversations.find((c) => c.users.find((u) => u.id == this.redirectOnUserId));
                    if (conversation) {
                        this.selectedConversationId = conversation.id;
                    } else {
                        const recipient = this.userMessageRecipients.find((r) => r.id === this.redirectOnUserId);
                        this.onConversationCreated({ recipients:[recipient] });
                    }
                    this.redirectOnUserId = null;
                }
            } catch (err) {
                console.error(err);
                this.$notify({
                    title: 'Erreur',
                    text: 'Une erreur est survenue lors du chargement de la page',
                    type: 'error'
                });
            } finally {
                this.isConversationsLoading = false;
                this.setLoading(false);
            }
        },

        async fetchMessages() {
            try {
                const selectedConversationId = this.selectedConversationId;
                clearTimeout(this.setNotSeenTimeout);
                this.isMessagesLoading = true;

                const query = {
                    page: this.messagesCurrentPage,
                    include: 'attachments',
                    otherConversations: this.tab === 1 ? '1' : '0'
                };
                const { messages, count, totalPages, err } = await this.repos.messaging.getMessages(this.selectedConversationId, query);
                if (err) {
                    throw new Error(err);
                }

                if (this.selectedConversationId !== selectedConversationId) {
                    return;
                }

                if (messages.length > 0) {
                    messages[messages.length - 1].last = true;
                }

                let lastMessageNotSeen = null;
                for (const message of messages) {
                    if (!lastMessageNotSeen && !message.isMe && !message.seen) {
                        lastMessageNotSeen = message;
                    }
                    this.messages.unshift(message);
                }

                if (lastMessageNotSeen) {
                    this.setNotSeenTimeout = setTimeout(() => {
                        this.setMessageSeen(lastMessageNotSeen);
                    }, 1500);
                }

                this.messagesCount = count;
                this.messagesTotalPages = totalPages;

                if (this.$refs.messageList) {
                    const previousMessagesScrollHeight = this.$refs.messageList.$el.scrollHeight;
                    if (this.firstConversationFetch) {
                        // On scroll en bas de la page lors du premier chargement
                        this.firstConversationFetch = false;
                        this.$nextTick(() => {
                            this.$nextTick(() => {
                                this.$refs.messageList.$el.scrollTop = this.$refs.messageList.$el.scrollHeight;
                            });
                        });
                    } else if (messages.length > 0) {
                        // On scroll à la position ou l'on était avant d'avoir rajouter les nouveaux messages
                        this.$nextTick(() => {
                            const now = this.$refs.messageList.$el.scrollHeight - previousMessagesScrollHeight;
                            this.$refs.messageList.$el.scrollTop = now;
                        });
                    }
                }
                this.lastMessageReached = messages.length === 0 && this.messages.length > 0;
            } catch (err) {
                console.error(err);
                this.$notify({
                    title: 'Erreur',
                    text: 'Une erreur est survenue lors du chargement de la page',
                    type: 'error'
                });
            } finally {
                this.isMessagesLoading = false;
            }
        },

        async setMessageSeen(message) {
            try {
                const conversation = this.conversations.find((c) => c.id === message.groupId);
                conversation.unreadCount = 0;
                await this.repos.messaging.setMessageSeen(message.groupId, message.id);
            } catch (err) {
                console.error(err);
            }
        },
        
        async toggleTag(conversation) {
            try {
                const { success, err } = await this.repos.messaging.toggleConversationtTag(conversation.id);
                if (success) {
                    this.fetchConversations(this.selectedConversationId, true);
                } else {
                    throw new Error(err);
                }
            } catch (err) {
                console.error(err);
            }
        },

        async setConversationArchived(conversation, archived) {
            try {
                this.setLoading(true);

                const body = {
                    conversation: {
                        archived
                    }
                };
                const { err } = await this.repos.messaging.updateConversation(conversation.id, body);
                if (err) {
                    throw new Error(err);
                }
                conversation.archived = archived;
                this.$nextTick(() => {
                    if (!archived) {
                        this.archived = false;
                        this.fetchConversations(conversation.id, true);
                    } else {
                        this.fetchConversations(null, true);
                    }
                });
            } catch (err) {
                console.error(err);
                this.$notify({
                    title: 'Erreur',
                    text: 'Une erreur est survenue lors de la mise à jour de la conversation',
                    type: 'error'
                });
            } finally {
                this.setLoading(false);
            }
        },

        onMessageDeleted(index) {
            this.messages.splice(index, 1);
        },

        onMessageUpdated(data) {
            this.messages[data.index].content = data.content;
        },

        onConversationCreated(data) {
            this.newRecipients = data.recipients;
            this.selectedConversationId = this.newConversation.id;
            this.currentDisplayName = this.getConversationDisplayName(this.newConversation);
        },

        async onMessageCreated(message) {
            this.messages = [];
            if (this.selectedConversationId === -1) {
                this.selectedConversationId = null;
                this.newRecipients = [];
                this.conversations = [];
                await this.fetchConversations(message.groupId, false);
            } else {
                this.fetchMessages();
            }
        },

        onAttachmentDeleted(message, i) {
            message.attachments.splice(i, 1);
        },

        areConvUsersInactive(conversation) {
            if (conversation.id === -1) {
                return false;
            }
            return conversation.users
                .filter((u) => u.type === 'user')
                .every((u) => !u.active);
        },

        getConversationMe(conversation) {
            return conversation.users
                .find((m) => m.isMe);
        },

        getConversationOtherBuyer(conversation) {
            return conversation.users
                .filter((m) => m.type === 'buyer')
                .find((m) => !m.isMe);
        },

        getConversationOtherUser(conversation) {
            return conversation.users
                .filter((m) => m.type === 'user')
                .find((m) => !m.isMe);
        },

        getConversationDisplayName(conversation) {
            return conversation.users
                .filter((m) => !m.isMe)
                .sort((a) => {
                    return a.type === 'buyer' ? -1 : 1;
                })
                .map((m) => {
                    if (m.id === null) {
                        return '';
                    }

                    if (!m.name && !m.firstname) {
                        return '';
                    }
                    return `${m.name ? m.name : ''} ${m.firstname ? m.firstname : ''}`;
                })
                .join(', ');
        },

        computeMessageContainerHeight() {
            const header = document.querySelector('main .v-toolbar');
            const footer = document.querySelector('#footer');
            const messageContainer = document.querySelector('#message-input-container');
            const conversationHeader = document.querySelector('#conversation-header');

            if (!header || !footer || !messageContainer || !conversationHeader) {
                return;
            }

            const rect1 = header.getBoundingClientRect();
            const rect2 = footer.getBoundingClientRect();
            const rect3 = messageContainer.getBoundingClientRect();
            const rect4 = conversationHeader.getBoundingClientRect();

            const height = window.innerHeight - (rect1.height + rect2.height + rect3.height + rect4.height);

            this.messageContainerHeight = `${height}px`;
        }
    },

    computed: {
        selectedConversation() {
            if (this.selectedConversationId === -1) {
                return this.newConversation;
            } else {
                return this.conversations.find((c) => this.selectedConversationId === c.id);
            }
        },

        newConversation() {
            return {
                id: -1,
                created: new Date().toISOString(),
                application: 'clients',
                context: null,
                contextCode: null,
                unreadCount: 0,
                message: null,
                users: this.newRecipients.map((r) => ({
                    id: r.id,
                    type: r.type,
                    firstname: r.name,
                    name: r.firstname,
                    profilePictureDocumentId: r.profilePictureDocumentId,
                    isMe: false
                }))
            };
        },

        hasOtherNewMessages() {
            return this.otherConversationsHasUnreadMessages || (
                this.tab === 1 && this.conversations.some((c) => c.unreadCount > 0)
            );
        },

        archivedChipTooltip() {
            let text = '';
            const conv = this.selectedConversation;

            if (conv.archivedDate) {
                if (conv.archived)  {
                    const user = conv.users.find((u) => u.type === conv.archivedByUserType && u.id === conv.archivedByUserId);
                    if (user) {
                        if (user.type === 'user') {
                            text = `Cette conversation a été archivée par l'utilisateur ${user.name} ${user.firstname} le ${this.$options.filters.toDayMonthYearDate(conv.archivedDate)}`;
                        } else {
                            text = `Cette conversation a été archivée par l'acquéreur ${user.name} ${user.firstname} le ${this.$options.filters.toDayMonthYearDate(conv.archivedDate)}`;
                        }
                    }
                } else {
                    const user = conv.users.find((u) => u.type === conv.unArchivedByUserType && u.id === conv.unArchivedByUserId);
                    if (user) {
                        if (user.type === 'user') {
                            text = `Cette conversation a été désarchivée par l'utilisateur ${user.name} ${user.firstname} le ${this.$options.filters.toDayMonthYearDate(conv.unArchivedDate)}`;
                        } else {
                            text = `Cette conversation a été désarchivée par l'acquéreur ${user.name} ${user.firstname} le ${this.$options.filters.toDayMonthYearDate(conv.unArchivedDate)}`;
                        }
                    }
                }
            }

            return text;
        },

        isAllowedToSendMessage() {
            if (!this.selectedConversation) {
                return false;
            }
            
            if (this.tab !== 0) {
                return false;
            }

            if (this.areConvUsersInactive(this.selectedConversation)) {
                return false;
            }

            if (this.isUser) {
                if (this.selectedConversation.archived) {
                    return false;
                }
            } else {
                const isUserStillVisible =  this.selectedConversation.users
                    .filter((u) => u.type === 'user')
                    .some((u) => this.userMessageRecipients.some((u2) => u2.id == u.id && u2.type === u.type));
                // Il faut que l'utilisateur de la conversation soit toujours visible parmi les interlocuteurs
                if (!isUserStillVisible){
                    return false;
                }
            }

            return true;
        }
    },

    watch: {
        tab() {
            this.fetchConversations(null, true);
        },

        selectedConversationId() {
            this.messages = [];
            this.firstConversationFetch = true;
            this.messagesCurrentPage = 1;
            this.fetchMessages();
            if (this.selectedConversationId) {
                this.conversations.forEach((conv) => {
                    if (conv.id === this.selectedConversationId) {
                        this.currentDisplayName = this.getConversationDisplayName(conv);
                    }
                });
            } else {
                this.currentDisplayName = '';
            }
            this.$nextTick(() => {
                if (this.isUser) {
                    this.$refs.createMessageInput.resetAiAssistant();
                }
                this.computeMessageContainerHeight();
            });
        }
    },

    created() {
        this.fetchConversations(null, false);

        if (this.$route.query.userId) {
            this.redirectOnUserId = parseInt(this.$route.query.userId);
            this.$router.replace({ path: '/messages' });
        }

        this.$nextTick(() => {
            if (this.$refs.messageList) {
                this.$refs.messageList.$el.addEventListener('scroll', () => {
                    if (!this.isMessagesLoading && this.$refs.messageList.$el.scrollTop === 0 && !this.lastMessageReached) {
                        this.messagesCurrentPage++;
                        this.fetchMessages();
                    }
                });
            }

            if (this.$refs.conversationsList) {
                this.$refs.conversationsList.$el.addEventListener('scroll', () => {
                    const scrollTop = this.$refs.conversationsList.$el.scrollTop;
                    const scrollHeight = this.$refs.conversationsList.$el.scrollHeight;
                    const clientHeight = this.$refs.conversationsList.$el.clientHeight;
                    if ((scrollTop + clientHeight >= scrollHeight - 50) && !this.isConversationsLoading) {
                        if (!this.hasNoMoreConversations) {
                            this.conversationsCurrentPage++;
                            this.fetchConversations(null, false);
                        }
                    }
                });
            }

            this.computeMessageContainerHeight();
            window.addEventListener('resize', () => {
                this.computeMessageContainerHeight();
            });

            if (this.$refs.programAutocomplete) {
                this.$refs.programAutocomplete.fetchPrograms({ limit: 10000 });
            }
        });
    }
};
</script>
